import { MediaSourceType } from '../MediaPopup/types';
import { DeviationTypes } from '../types/deviation';
export const ALLOWED_DEVIATION_TYPES = [
    DeviationTypes.IMAGE
];
export const ALLOWED_MEDIA_SOURCE_TYPES = [
    MediaSourceType.GALLERY,
    MediaSourceType.STASH
];
export const THUMB_WIDTH = 264;
export const THUMB_HEIGHT = 146;
export const MAX_COLORS = 6;
export const DEFAULT_TINT = 'rgba(6, 7, 13,0.14)';
export const DEFAULT_CUSTOMBOX_GRADIENTS = [
    1,
    2,
    3,
    4,
    5,
    6,
    7
];
export const DEFAULT_STATUS_GRADIENTS = [
    0,
    1,
    2,
    3,
    4,
    5
];
export const DEFAULT_COLORS = [
    '#ffffff',
    '#00e59b',
    '#2847f5',
    '#7579ff',
    '#f2406e',
    '#000000'
];
// GOTCHA: these are validated on the backend too so if you update the path here
// make they're updated there too
// https://phrac.deviantart.net/source/web/browse/master/vms/lib/background/v./background.php
export const DEFAULT_STATUS_PATTERNS = [
    'https://st.deviantart.net/eclipse/global/svg/status-background-1.svg',
    'https://st.deviantart.net/eclipse/global/svg/status-background-2.svg',
    'https://st.deviantart.net/eclipse/global/svg/status-background-3.svg',
    'https://st.deviantart.net/eclipse/global/svg/status-background-4.svg'
];
export const DEFAULT_CUSTOMBOX_PATTERNS = [
    'https://st.deviantart.net/misc/custombox/patterns/marble.png',
    'https://st.deviantart.net/misc/custombox/patterns/neon-waves.png',
    'https://st.deviantart.net/misc/custombox/patterns/party-glitter.png',
    'https://st.deviantart.net/misc/custombox/patterns/pink-diamonds.png'
];

//# sourceMappingURL=constants.js.map